module.exports = __webpack_public_path__ + "img/burger.a3e0f7a4.svg";